<template>
  <section id="app-scan-nfc">
    <div>
      <!-- **********************************
      ********** BOUTON LYFPAY **********
      *********************************** -->
      <payment-btn
        v-if="showLyfpay"
        :title="$t('button.scan_lyfpay')"
        color="red"
        logo="lyfpay"
        class="my-2"
        @click="$emit('to-lyfpay')"
      />

      <!-- ***********************
      ********** DECORD **********
      ************************ -->
      <div
        v-if="creditOnly"
        class="text-center font-weight-bold headline white--text green py-3"
      >
        {{ $t('success.cb_debit') }}
      </div>
      <template v-if="ismodeSessionFloating">
        <div class="contactless-container">
          <div class="contactless-container__top">
            <img
              :src="AppImages.lockNfc"
              alt="nfc_logo"
              class="ma-auto"
              height="200"
            >
            <p class="text-center title">
              Déverrouiller
            </p>
          </div>
          <img
            :src="AppImages.lock"
            alt="nfc_logo"
            class="ma-auto"
            height="200"
          >
        </div>
      </template>
      <template v-else>
        <div class="d-flex">
          <img
            :src="AppImages.nfcWave"
            alt="nfc_logo"
            class="ma-auto"
            height="200"
          >
        </div>

        <p class="text-center title">
          {{ $t('field.scan.thx_presenting') }}<br>
          {{ ismodeSessionFloating ? $t('field.scan.ur_cashier_card'): action === 0 ? $t('field.scan.ur_support') : $t('field.scan.ur_payment') }}
        </p>
      </template>


      <bottom-action
        v-if="!ismodeSessionFloating"
        :btn-del="deletable"
        :btn-cancel="cancellable"
        :btn-cancel-disabled="(action === ActionEnum.credit && total > 0)"
        :btn-valid="action === ActionEnum.credit"
        :btn-del-disabled="action > 22 || fromIntent || action === ActionEnum.credit"
        :use-listener="false"
        :btn-valid-disabled="(action === ActionEnum.credit && total === 0)"
        @del="$emit('del')"
        @cancel="$emit('cancel')"
        @valid="$emit('valid')"
      />
    </div>
  </section>
</template>

<script>
import { ActionEnum, IconEnum, SCAN_TYPE } from '@/modules/Enums'
import { AppImages } from '@/modules/Images'
import { Scan } from '@/modules/Scan'
import { $alert } from '@/modules/Utils'

export default {
  name: 'ContactlessScan',

  props: {
    action: { type: Number, default: null },
    cancellable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    locked: { type: Boolean, default: false },
    creditOnly: { type: Boolean, default: false },
    resetScan: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true },
    fromIntent: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
    ismodeSessionFloating: { type: Boolean, default: false },
  },

  data () {
    return {
      ActionEnum,
      IconEnum,
      AppImages,
      nfcOnlineIsRunning: true,
      nfcDesktopTimeout: null,
      nfcDesktopIsReading: false,
      nfcValue: '',
      useDesktopListener: false
    }
  },

  computed: {
    usenfc () { return this.$store.state.usenfc },
    lyfpay () { return this.$store.state.teleparameters.LyfPay },
    showLyfpay () {
      return this.action === ActionEnum.cashlessDebit &&
        this.lyfpay.Integre === 1 &&
        this.lyfpay.Debit === 1
    }
  },

  watch: {
    resetScan () {
      if (IS_PAX) {
        setTimeout(this.startPaxNfc , 2500)
      } else if (IS_INGENICO) {
        setTimeout(this.startIngenicoNfc , 2500)
      }
    },
    useListener (newVal) {
      if (this.useDesktopListener) {
        if (newVal === true) {
          window.addEventListener('keypress', this.receiveDesktopNfc, false)
        } else {
          window.removeEventListener('keypress', this.receiveDesktopNfc, false)
        }
      }
    }
  },

  beforeMount () {
    if (this.creditOnly) {
      this.$emit('title', this.$i18n.t('title.cashless_reload_cb'))
    }
  },

  mounted () {
    // Mode online -> Controle plateforme
    if (this.usenfc) {
      if (IS_PAX) {
        // Start nfc for PAX
        this.startPaxNfc()
      } else if (IS_INGENICO) {
        this.startIngenicoNfc()
      } else if (IS_SUNMI) {
        this.startSunmiNfc()
      } else if (IS_IOS) {
        // Start nfc for ios
        nfc.getMifareUid()
          .then(uid => {
            // ===> START SCAN
            this.$emit('scan', uid)
          })
          .catch(error => {
            switch (error) {
              case 'Session invalidated by user':
                this.nfcOnlineIsRunning = false
                break
              case 'Feature not supported':
                this.failure('NO_NFC')
                break
              default:
                this.failure(error)
                break
            }
          })
      } else if (IS_ANDROID) {
        // Start nfc for android
        nfc.addNdefListener(this.manageDeviceTag, () => {}, this.failure)
        nfc.addTagDiscoveredListener(this.manageDeviceTag, () => {}, this.failure)
      } else {
        // Ecoute clavier
        this.useDesktopListener = true
        if (this.useListener) {
          window.addEventListener('keypress', this.receiveDesktopNfc, false)
        }
      }
    } else {
      this.manageRedirection()
    }
  },

  beforeDestroy () {
    // Arrêt du nfc
    if (this.usenfc) {
      if (IS_PAX) {
        Pax.stopNfc()
      } else if (IS_INGENICO) {
        Ingenico.stopNfc()
      } else if (IS_SUNMI) {
        CissAndroid.stopSunmiNfc()
      } else if (this.nfcOnlineIsRunning) {
        if (IS_ANDROID) {
          nfc.removeTagDiscoveredListener(this.manageDeviceTag, () => {}, this.failure)
          nfc.removeNdefListener(this.manageDeviceTag, () => {}, this.failure)
        } else if (IS_IOS) {
          nfc.invalidateSession()
        } else {
          window.removeEventListener('keypress', this.receiveDesktopNfc, false)
        }
      }
    }
  },

  methods: {
    startPaxNfc () {
      Pax.startNfc((uid) => {
          // ===> START CALL
          this.$emit('scan', uid)
        },
        (error) => {
          if (error.startsWith('PICC#5')) {
            $alert('Attention, vous tentez d\'effectuer une opération avec une carte bancaire', 'info')
          } else {
            $alert(this.$i18n.t('error.scan_retry'));
          }
          setTimeout(this.startPaxNfc, 2000)
        }
      )
    },
    startIngenicoNfc () {
      Ingenico.startNfc(
        (uid) => {
         // ===> START CALL
         this.$emit('scan', uid)
       },
       (error) => {
         $alert(error)
         setTimeout(this.startIngenicoNfc, 2000)
       }
     )
    },
    startSunmiNfc () {
      CissAndroid.startSunmiNfc(
        (uid) => {
         // ===> START CALL
         this.$emit('scan', uid)
       },
       (error) => {
         $alert(error)
         this.$router.replace('/home')
         // setTimeout(this.startSunmiNfc, 2000)
       }
     )
    },
    receiveDesktopNfc (e) {
      if (this.locked) {
        return
      }

      clearTimeout(this.nfcDesktopTimeout)

      if (e.keyCode === 13) { // => 'Enter'
        this.$store.commit('loader', false)
        this.nfcDesktopIsReading = false
        let uid = this.nfcValue
        this.nfcValue = ''

        // Contrôle du numéro reçu
        if (uid !== '') {
          let reg = /[a-z_A-Z_0-9]/

          if (uid.toUpperCase() !== uid || !reg.test(uid)) {
            $alert(this.$i18n.t('error.nfc_read_format'))
          } else {
            // Formattage uid (contrôle carte à piste)
            let index = uid.indexOf('=')
            if (index === -1) { // Lecture NFC
              uid = uid.toUpperCase()
            } else { // Lecture piste
              uid = uid.substring(0, index)
            }
            // ===> START SCAN
            this.$emit('scan', uid, index === -1 ? SCAN_TYPE.NFC : SCAN_TYPE.SWIPE)
          }
        }
      } else {
        // Ajout touche à la valeur du nfc
        this.nfcValue += String.fromCharCode(e.keyCode)
        // Si pas déjà fait, démarrage loader
        if (!this.nfcDesktopIsReading) {
          this.nfcDesktopIsReading = true
          $alert(false)
          this.$store.commit('loader', this.$i18n.t('loader.scan_support'))
        }
        // Reset en cas d'erreur de saisie (aucun autre caractère immédiat)
        this.nfcDesktopTimeout = setTimeout(() => {
          this.$store.commit('loader', false)
          this.nfcDesktopIsReading = false
          this.nfcValue = ''
        }, 200)
      }
    },
    manageDeviceTag (nfcEvent) {
      let {tag} = nfcEvent

      if (tag.id) {
        // Vibration courte
        navigator.vibrate(300)
        // ===> START SCAN
        this.$emit('scan', Scan.bytesToHexString(tag.id).toUpperCase())
      } else {
        // Vibration longue
        navigator.vibrate(800)
        $alert(this.$i18n.t('error.nfc_card_not_supported'))
      }
    },
    failure (reason) {
      if (!this.nfcOnlineIsRunning) return

      this.nfcOnlineIsRunning = false

      if (reason === 'NO_NFC') {
        // Désactivation sans contact
        this.$store.commit('usenfc', false)
        localStorage.setItem('usenfc', false)
        // Changement du scan par défaut
        this.$emit('to-scan-choice', this.$i18n.t('error.nfc_not_detected'), 0)
      } else if (reason === 'NFC_DISABLED') {
        // Open device settings for user accept
        $alert(this.$i18n.t('info.nfc_disabled'), 'info', '', -1, [{
            title: this.$i18n.t('info.access_to_params'),
            color: 'success',
            click: () => {
              nfc.showSettings()
              this.$emit('del')
            }
          },{
            title: this.$i18n.t('info.change_scan_method'),
            color: 'info',
            click: () => {
              this.$emit('to-scan-choice', this.$i18n.t('info.nfc_disabled'), 0)
            }
          }],
          null,
          false
        )
      } else {
        $alert(this.$i18n.t('info.nfc_problem', { problem: reason }), 'info')
      }
    },
    // **********************************************************************
    manageRedirection () {
      if (this.action === ActionEnum.mobil) {
        this.$emit('to-keyboard', true)
      } else {
        this.$emit('to-qr-scanner', true)
      }
    }
  }
}
</script>
